module.exports = __webpack_public_path__ + "img/red_034.d6d35cb3.png";